import { IconType, MessageBar } from '@repo/ui/components';
import { IValidationToastNotification } from '../../common';
import { getErrorMessageForError } from './ErrorMessageMapper';
import { TMessageBarSeverity } from 'types';

interface IErrorNotification extends IValidationToastNotification {
  errorCode: number;
}

interface ICustomErrorNotifications extends IValidationToastNotification {
  errorCode: number;
  title: string;
}

export const ErrorNotification = ({
  severityLevel = TMessageBarSeverity.ERROR,
  errorCode,
  onClose,
}: IErrorNotification) => (
  <MessageBar
    severity={severityLevel}
    onClose={onClose}
    dismissible
    className="w-[40rem] border-0 py-8 gap-6 rounded-lg [&_.tw-dismiss-button]:-top-4"
    alertIcon={{ icon: IconType.NewNextWarningSolid, size: 32 }}
  >
    <span className="text-lg/[175%] font-extrabold">{getErrorMessageForError(errorCode)}</span>
  </MessageBar>
);

/**
 * The CustomErrorNotification component renders a Messagebar with specified severity level, title, and
 * onClose function.
 * @param {ICustomErrorNotifications} props - The `props` parameter in the `CustomErrorNotification`
 * component is an object that contains the following properties:
 */
export const CustomErrorNotification = ({
  severityLevel = TMessageBarSeverity.ERROR,
  errorCode,
  title,
  onClose,
}: ICustomErrorNotifications) => {
  const getTitle = (errorCode: number, title: string) => {
    return `${getErrorMessageForError(errorCode)} ${title}`;
  };

  return (
    <MessageBar severity={severityLevel} onClose={onClose} dismissible className="max-w-1/3">
      {getTitle(errorCode, title)}
    </MessageBar>
  );
};
